
import { useState } from "react";
import { StudentLoginForm } from "./StudentLoginForm";
import { StudentRegisterForm } from "./StudentRegisterForm";

type StudentAuthFormProps = {
  isLogin?: boolean;
  onForgotPassword?: () => void;
};

export const StudentAuthForm = ({ 
  isLogin = false,
  onForgotPassword 
}: StudentAuthFormProps) => {
  const logoUrl = "/lovable-uploads/548da3a0-90a0-43e9-a23b-6223b2e67eed.png";
  
  return isLogin ? (
    <StudentLoginForm logoUrl={logoUrl} onForgotPassword={onForgotPassword} />
  ) : (
    <StudentRegisterForm logoUrl={logoUrl} />
  );
};
